import React, { useEffect, useState, useRef } from 'react';
import StatisticsGrid from './StatisticsGrid/StatisticsGrid';
import ResourcesProductUpdate from './ResourcesProductUpdate';
import ResourcesSchedulingBox from './ResourcesSchedulingBox';
import ResourcesUIBox from './ResourcesUIBox';
import ResourcesLatestNews from './ResourcesLatestNews';
import Footer from './Footer/Footer';
import '../components/App.css'

const getIsDarkMode = () => document.documentElement.getAttribute('data-theme') === 'dark';

const tabOptions = [
  { name: 'Blogs', icon: true },
  { name: 'Updates', icon: true },
  { name: 'Latest news', icon: true }
];

const ResourcesRoute = () => {
  const [dark, setDark] = useState(getIsDarkMode());
  const [activeTab, setActiveTab] = useState('Blogs');
  const tabRef = useRef(null);

  useEffect(() => {
    const observer = new MutationObserver(() => setDark(getIsDarkMode()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  // Scroll to tab group when tab changes
  useEffect(() => {
    if (tabRef.current) {
      tabRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [activeTab]);

  return (
    <>
      <section
        style={{
          padding: '120px 0 60px 0',
          background: dark ? '#18181b' : '#fafbfc',
          color: dark ? '#fff' : '#18181b',
          textAlign: 'center',
          minHeight: 400,
        }}
      >
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 600,
          marginBottom: 32,
          color: dark ? '#fff' : '#18181b',
        }}>
          Your Trusted Hub for Healthcare Innovation & AI Insights
        </h1>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 48 }}>
  <svg width="220" height="24" viewBox="0 0 220 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="12" x2="90" y2="12" stroke="#0098d0" strokeWidth="3" />
    <path
      d="M90,12 
         L95,12 
         L97,6 
         L101,18 
         L105,12 
         L110,12 
         L112,6 
         L116,18 
         L120,12 
         L125,12 
         L127,6 
         L131,18 
         L135,12"
      fill="none"
      stroke="#8CA0A8"
      strokeWidth="3"
      style={{
        strokeDasharray: 100,
        strokeDashoffset: 100,
        animation: 'heartbeatAnim 2s linear infinite',
      }}
    />
    <line x1="135" y1="12" x2="200" y2="12" stroke="#8CA0A8" strokeWidth="3" />
  </svg>
</div>

        <div ref={tabRef} style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 0,
          background: dark ? '#23232a' : '#e5e7eb',
          borderRadius: 14,
          maxWidth: 480,
          margin: '0 auto',
          boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
          overflow: 'hidden',
        }}>
          {tabOptions.map((tab, idx) => (
            <button
              key={tab.name}
              onClick={() => setActiveTab(tab.name)}
              style={{
                flex: 1,
                padding: '16px 0',
                fontSize: '1.1rem',
                fontWeight: 600,
                color: activeTab === tab.name ? '#fff' : '#0098d0',
                background: activeTab === tab.name ? '#0098d0' : 'transparent',
                border: 'none',
                outline: 'none',
                cursor: activeTab === tab.name ? 'default' : 'pointer',
                transition: 'background 0.2s, color 0.2s',
                borderRadius: activeTab === tab.name ? 8 : 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
              }}
              disabled={activeTab === tab.name}
            >
              {tab.name}
              {activeTab !== tab.name && (
                <span style={{ marginLeft: 8, display: 'flex', alignItems: 'center' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M9 6l6 6-6 6" stroke="#0098d0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              )}
            </button>
          ))}
        </div>
        <hr style={{
          margin: '60px auto 0 auto',
          border: 0,
          borderTop: `2px solid ${dark ? '#334155' : '#cbd5e1'}`,
          width: '90%',
        }}/>
      </section>
      {activeTab === 'Blogs' && <StatisticsGrid />}
      {activeTab === 'Updates' && <><ResourcesProductUpdate /><ResourcesSchedulingBox /><ResourcesUIBox /></>}
      {activeTab === 'Latest news' && <ResourcesLatestNews />}
      <Footer />
    </>
  );
};

export default ResourcesRoute; 